import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { InputLabel } from "@mui/material";
import Text from "components/common/Text";

export default function DialogEditManufacturer({
  value,
  open,
  handleClose,
  data,
  handleOnChange,
  handleClickSubmit,
  handleOnChangeEditFile,
  editfile,
  // thumbnail,
}) {
  // console.log(thumbnail, "thumbnailthumbnail");

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            marginTop: "1.2rem",
          }}
        >
          {"Edit manufacturer name"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <input
              style={{
                padding: "10px 15px",
                width: "15rem",
                height: "44px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
              }}
              defaultValue={data}
              onChange={handleOnChange}
              onInput={(e) => {
                e.target.value = e.target.value
                  .trimStart()
                  .replace(/[^a-zA-Z ]*/g, "");
              }}
            ></input>
          </DialogContentText>
        </DialogContent>

        <DialogContent>
          <DialogContentText>
            <InputLabel
              sx={{ fontSize: "14px", color: "#111111" }}
              id="demo-simple-select-label"
            >
              Edit Vehicle model image
            </InputLabel>

            <div style={{ display: "flex", gap: "10px" }}>
              {/* <img src={thumbnail} alt="Vehicle" style={{ width: "70px" }} /> */}
              <input
                id="file"
                name="photo"
                type="file"
                className="form-control"
                accept="image/*"
                style={{
                  padding: "10px 15px",
                  width: "15rem",
                  height: "44px",
                  background: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                  borderRadius: "6px",
                  marginTop: "10px",
                }}
                onChange={(e) => {
                  handleOnChangeEditFile(e.currentTarget.files[0]);
                }}
                 />
            </div>

            {editfile.error ? (
              <Text sx={{ fontSize: "14px", color: "red" }}>
                {editfile.message}
              </Text>
            ) : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{
              background: "#04AAD",
              marginRight: "1rem",
              width: "100.17px",
              height: "40px",
              marginBottom: "1.2rem",
              cursor: "pointer",
              fontSize: "12px",
            }}
            autoFocus
            disabled={!value && !editfile}
            onClick={() => handleClickSubmit()}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
